export default __webpack_public_path__ + "static/media/Atwell.01c12076.jpg";